import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { combine } from 'src/app/shared/utilities/route';
import { NeedsWorkApprovalAssignment } from 'src/app/shared/models/needs-work-approval-assignment.model';
import { formatDate } from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class NeedsApprovalAlertService {
    private readonly coreApiPath: string;

    constructor(@Inject(APP_CONFIG) settings: Settings, private readonly http: HttpClient) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'ayanova');
    }

    getNeedsWorkApprovalAssignments(candidateId: number): Observable<NeedsWorkApprovalAssignment[]> {
        const url = `${this.coreApiPath}/candidate/${candidateId}/assignments/needs-work-approval`;
        return this.http.get<NeedsWorkApprovalAssignment[]>(url);
    }

    static needsWorkApproval(data: any): boolean {
        const locale = 'en-US';
        const sourceFormat = 'yyyy/MM/dd';
        const today = formatDate(new Date(), sourceFormat, locale);
        const needsWorkApproved = data.needsWorkApproval === true;

        if (data.workApprovalDate === null) {
            return needsWorkApproved;
        } else {
            const workApprovalDate = formatDate(data.workApprovalDate, sourceFormat, locale);
            return workApprovalDate > today && needsWorkApproved;
        }
    }
}
